import { HLog } from "src/core/helpers"
import ModuleFirstSetting from "src/core/modules/firstsetting"
// import ModuleCategoryScreen from "src/core/modules/categoryscreen"
import ModuleV1Page from "src/core/modules/v1page"
import ModuleDev from "src/core/modules/dev"
import ModuleIconHiOutline from "src/core/modules/iconHiOutline"
import ModuleSetting from "src/core/modules/setting"
import ModuleSetting2FA from "src/core/modules/setting2fa"
import ModuleRedirectToken from "src/core/modules/redirectToken"
import ModuleDevSimulator from "src/core/modules/dev_simulator"
import ModuleAppDNT from "src/modules/app_dnt"
import ModuleCore from "src/core/modules/core"
import ModuleReactGA from "src/modules/reactga"
import ModuleSignalR from "src/modules/signalR"

import Lang_en from "../assets/i18n/en.json"
import Lang_vi from "../assets/i18n/vi.json"

import { store } from "src/store/store"
import { logout, updateHeaderTitle } from "src/App/App.actions"

import "src/assets/scss/theme-layout.css"
const AppConfig: IConfigApp = {
  appInfo: {
    title: "Diary N Tasks",
    appName: "DiaryNTask",
    home: "/",
    acceptedFiles:
      "image/*, .txt, .pdf, .doc, .docx, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    acceptedFilesNotIncludeImg:
      ".pdf, .doc, .docx, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    GoogleClientId:
      "998920742012-04u6n4nvp3fmvthclu6tmkucms11cbov.apps.googleusercontent.com",
    GAId: "UA-119777650-2",
    pathLogo: "/config/logo.png",
    pathMainLogo: "/config/logo.png",
    useLogoServer: false,
    loginBannerImages: [
      {
        id: "1",
        url: "https://wac-cdn-2.atlassian.com/image/upload/f_auto,q_auto/dam/jcr:b86a32cb-0aa8-4783-aa81-9592d4fbf829/jsw-header-illustrations---v3.png?cdnVersion=239",
      },
      {
        id: "2",
        url: "https://wac-cdn-2.atlassian.com/image/upload/f_auto,q_auto/dam/jcr:5fc99937-d607-4948-b3d4-7ca7d700d5f5/agile_2.svg?cdnVersion=239",
      },
    ],
    isCustomLang: true,
    defaultLang: "en",
    defaultLangBundles: [
      "common",
      "dnt",
      "screen_MY_PROFILE",
      "screen_MY_COMMUNICATIONS",
      "setting2fa",
      "check_idle",
    ],
    currentVersionLang: "2023/06/01 10:41",
    currentVersionEditor: "3",
    supportSubdomainConfig: true,
    openDetailInModal: true,
    targetOpenUrlDetail: "_self",
    hasSignalR: true,
    signalRHub: "/NotificationHub",
    signalRKey: "jkfghweUIT0923klhgfvas65t823fajkwq",
    //GooglePlaceApiKey: "AIzaSyCfE6DSnKS3zubPoHaOOgaZqnK-3LNWLPY", //prj DEB DEV
    // GooglePlaceApiKey: "AIzaSyBCngEVc4wGqeENChmkZMXL0I3LWZGhSPY", //prj AllianceITSC
  },
  configApi: {
    baseUrl: "https://diaryntask-api-dev.allianceitsc.com",
    // baseUrl: "https://demo-api.diaryntasks.com",
    fnLogout: () => {
      // console.warn("logout")
      store.dispatch(logout())
    },
  },
  configI18n: {
    defaultNS: "common",
    resources: {
      ui: {
        common: Lang_en,
      },
      en: {
        common: Lang_en,
      },
      vi: {
        common: Lang_vi,
      },
    },
    interpolation: {
      escapeValue: false,
    },
  },
  configAuth: {
    afterLogin: () => {
      // HLog.logW("afterLogin")
    },
  },
  fnList: {
    dispatchFromStore(action) {
      store.dispatch(action)
    },
    updateHeaderTitle: title => {
      store.dispatch(updateHeaderTitle(title))
    },
    onAfterInit: function (HConfig) {
      HLog.logW("After init", HConfig)
    },
  },
  modules: [
    ModuleCore,
    ModuleDev,
    ModuleDevSimulator,
    ModuleFirstSetting,
    // ModuleCategoryScreen,
    ModuleV1Page,
    ModuleIconHiOutline,
    ModuleSetting,
    ModuleAppDNT,
    ModuleSetting2FA,
    ModuleRedirectToken,
    ModuleReactGA,
    ModuleSignalR,
  ],
  UIAppConfig: {
    numeralFormat: "0,0.[0]",
    numeralFormatMoney: "0,0.[00]",
    isCheckInvalidProjectId: true,
    ignoreNoProjectId: false,
    timeFormat: "HH:mm",
    dateFormat: "DD-MMMYY", //MomentJS
    datetimeFormat: "DD-MMMYY HH:mm", //MomentJS
    widthMobile: 1000,
    symbolDecimal: ",",
    symbolThousand: ".",
    expandBgColor: "#e4e5e6", //#93d4e3
  },
}

export default AppConfig
